import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SubmissionAttachment } from '../../../../models/submissions/submission-attachment';

@Component({
  selector: 'app-fiduciary-submission-submitted-file-list',
  templateUrl: './fiduciary-submission-submitted-file-list.component.html',
  styleUrls: ['./fiduciary-submission-submitted-file-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiduciarySubmissionSubmittedFileListComponent {
  @Input() files: SubmissionAttachment[] = [];
  @Input() receivedDate: string = '';
}
